import type { ReactNode } from 'react';

export const symbol_airplanemode_inactive: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m551-621 311 217q8 6 13 14.5t5 19.5v19q0 23-18.5 34.5T823-313l-175-69-239-239v-188q0-29 21-50t50-21q29 0 50 21t21 50v188Zm-71 482L329-93q-17 5-30.5-5.5T285-126v-19q0-8 4-15.5t11-12.5l109-76v-172L137-311q-20 8-38.5-4T80-350v-18q0-11 5-19.5T98-402l212-150L77-785q-9-9-9-21t9-21q9-9 21-9t21 9l708 709q9 9 9 21.5T827-76q-8 8-21 7.5T785-77L551-311v62l108 74q7 5 11 12.5t4 15.5v20q0 17-13.5 27T630-95l-150-44Z"
		/>
	</svg>
);
